<template>
  <div>
    <el-page-header @back="goBack" content="新增订阅"></el-page-header>
    <div class="addsubscription-page">
      <div class="edit-form">
        <el-form :model="addform" :rules="addsubscriptionrules" ref="addsubscriptions" label-width="120px" size="small">
          <el-form-item label="品牌ID" prop="brandid">
            <el-col :span="16">
              <el-select style="width:200px;" v-model="addform.brandid" filterable placeholder="请选择品牌">
                <el-option
                  v-for="item in brandids"
                  :key="item.brandId"
                  :label="item.name"
                  :value="item.brandId">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-button class="quickbtn" @click="addBrand()">新增品牌</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="用户" prop="mainid">
            <el-col :span="16">
              <el-select style="width:200px;" v-model="addform.userId" filterable placeholder="请选择用户" @change="getUserMainid(addform.userId)">
                <el-option
                  v-for="item in mainids"
                  :key="item.userId"
                  :label="item.email"
                  :value="item.userId"
                  :disabled="item.userId == addform.duserid">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-button class="quickbtn" @click="goToAddUser()">新增用户</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="代理用户" prop="agency">
            <el-col :span="16">
              <el-select style="width:200px;" v-model="addform.duserid" filterable placeholder="请选择代理" @change="getAgencyMainid(addform.duserid)">
                <el-option
                  v-for="item in dmainids"
                  :key="item.userId"
                  :label="item.email"
                  :value="item.userId"
                  :disabled="item.userId == addform.userId">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-button class="quickbtn" @click="goToAddUser()">新增代理</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="主负责人" prop="CSM">
            <el-col :span="16">
              <el-select style="width:200px;" v-model="addform.CSM" filterable placeholder="请选择主负责人" @change="getCSMMainid(addform.CSM)">
                <el-option
                  v-for="item in mainids1"
                  :key="item.userId"
                  :label="item.email"
                  :value="item.userId"
                  :disabled="item.userId == addform.CSM">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              
            </el-col>
          </el-form-item>
          <el-form-item label="副负责人" prop="DepCSM">
            <el-col :span="16">
              <el-select style="width:200px;" v-model="addform.DepCSM" filterable placeholder="请选择副负责人" @change="getDepCSMMainid(addform.DepCSM)">
                <el-option
                  v-for="item in mainids1"
                  :key="item.userId"
                  :label="item.email"
                  :value="item.userId"
                  :disabled="item.userId == addform.DepCSM">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              
            </el-col>
          </el-form-item>
          <el-form-item label="订阅名称" prop="name">
            <el-col :span="16">
              <el-input style="width:200px;" v-model="addform.name"></el-input>
            </el-col>
            <el-col :span="8"></el-col>
          </el-form-item>
          <el-form-item label="套餐等级" prop="packageid">
            <el-col :span="16">
              <el-select style="width:200px;" v-model="addform.packageid" filterable placeholder="请选择套餐等级" @change="selectPackage(addform.packageid)">
                <el-option
                  v-for="item in packageids"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8"></el-col>
          </el-form-item>
          <el-form-item label="监测频次">
            <el-col :span="16">
              <el-select style="width: 200px;" v-model="addform.monitortype" placeholder="请选择监测频次" @change="selectType">
                <el-option
                  v-for="item in monitortype"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">           
            </el-col>
          </el-form-item>
          <el-form-item label="监测时间">
            <el-col :span="16" v-if="addform.monitortype == 2 || addform.monitortype == 3" style="padding-bottom: 10px;">
              <el-radio-group v-model="isDefault" size="mini" @change="selectDefault">
                <el-radio-button label="1">默认</el-radio-button>
                <el-radio-button label="0">自定义</el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col :span="16" v-if="addform.monitortype != 4" class="checkmonitortime">
              <el-checkbox-group v-model="addform.monitortime" :min="monitortime_min" :max="monitortime_max" class="add-sub-checkbox-group">
                <el-checkbox v-for="t in monitortime" :label="t" :key="t" :disabled="addform.monitortype == ''">{{ t }}</el-checkbox>
              </el-checkbox-group>
            </el-col>
            <el-col :span="16" v-if="addform.monitortype == 4">
              每周一更新
            </el-col>
          </el-form-item>
          <el-form-item label="定制报告" prop="url">
            <el-col :span="16">
              <el-input v-model="addform.url"></el-input>
            </el-col>
            <el-col :span="8"></el-col>
          </el-form-item>
          <el-form-item label="开始时间" prop="init">
            <el-col :span="16">
              <el-date-picker style="width:200px;"
                :disabled="dialogtype === 1"
                v-model="addform.init"
                type="date"
                placeholder="选择日期"
                @change="getExpireDate()">
              </el-date-picker>
            </el-col>
            <el-col :span="8"></el-col>
          </el-form-item>
          <el-form-item label="到期时间" prop="expire">
            <el-col :span="16">
              <el-date-picker style="width:200px;"
                v-model="addform.expire"
                type="date"
                placeholder="到期时间"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-col>
            <el-col :span="8"></el-col>
          </el-form-item>
          <el-form-item label="渠道" prop="channel">
            <el-col :span="16">
              <el-select style="width:200px;" v-model="addform.channel" filterable placeholder="请选择渠道" multiple collapse-tags @change="getChannelName(addform.channel)">
                <el-option
                  v-for="item in channels"
                  :key="item.ChannelId"
                  :label="item.ChannelName"
                  :value="item.ChannelId">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-checkbox v-if="showsaletype" style="margin-left: 15px;" v-model="addform.saletype">升级</el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item label="品类" prop="category" v-if="false">
            <el-col :span="16">
              <el-input style="width:200px;" v-model="addform.category"></el-input>
            </el-col>
            <el-col :span="8">
            </el-col>
          </el-form-item>
          <el-form-item label="投诉点数" prop="tscount">
            <el-col :span="16">
              <el-input style="width:80px;" v-model="addform.tscountadd" :disabled="checkexpire"></el-input>
              <span class="totalpointscount"><i v-if="!checkexpire">剩余：{{ addform.tscount }}</i></span>
            </el-col>
            <el-col :span="8">
              <el-checkbox style="margin-left: 15px;" v-model="checkexpire">包月</el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancelDialog('addsubscriptions')" size="small">取 消</el-button>
            <el-button :loading="adddisabled" v-if="dialogtype !== 2" type="primary" @click="confirmAdd('addsubscriptions')" size="small">确 定</el-button>
            <el-button :loading="editdisabled" v-if="dialogtype === 2" type="primary" @click="confirmEdit('addsubscriptions')" size="small">确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog
      title="新增品牌"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="addBrandDialog"
      width="700px">
      <div class="edit-form">
        <el-form :model="addform" :rules="brandrules" ref="addbrandform" label-width="120px" size="small">
          <el-form-item label="品牌名称(中)" prop="name">
            <el-col :span="24">
              <el-input v-model="addform.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌名称(英)" prop="brand">
            <el-col :span="24">
              <el-input v-model="addform.brand"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Logo">
            <el-col :span="12">
              <el-input v-model="addform.logo"></el-input>
            </el-col>
            <el-col :span="12">
              <el-upload
                :show-file-list="false"
                class="upload-logo"
                name="logo"
                :limit="999"
                :action="uploadlogourl"
                :headers="uploadlogoheaders"
                :on-success="uploadsuccess">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>              
            </el-col>
          </el-form-item>
          <el-form-item label="关键词" prop="keywords">
            <el-col :span="24">
              <el-input type="textarea" :rows="2" v-model="addform.keywords"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌序列号">
            <el-col :span="24">
              <el-input v-model="addform.trademark"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog('addbrandform')" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmAddBrand('addbrandform')" size="small" :disabled="disableaddbtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      custom-class="viewlogodialog"
      title="查看Logo"
      :visible.sync="viewlogo"
      width="400px">
      <div id="brandlogoid"></div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data(){
    return{
      loading: false,
      query: {
        search: '',
        page: 1,
        size: this.getLocalStorage('pagesize4') ? this.getLocalStorage('pagesize4') * 1 : 25,
      },
      currentPage: 1,
      tablelist: [],
      totalbrand: 0,
      addSubscriptionDialog: false,
      isDefault: 1, // 1默认；0自定义
      addform: {
        brandid: '',
        mainid: '',
        name: '',
        init: '',
        expire: '',
        packageid: '',
        channel: '',
        category: '',
        userId: '',
        channelname: '',
        dmainid: '',
        tscount: null,
        tscountadd: 0,
        saletype: false,
        duserid: '',
        url: '',
        monitortype: 1,
        monitortime: [],
        CSM: '',
        DepCSM: ''
      },
      checkexpire: false,
      brandids: [],
      mainids: [],
      mainids1: [],
      dmainids: [{
        email: '无',
        mainId: ''
      }],
      channels: [],
      packageids: [],
      monitortype: [{
        value: 1,
        name: '8次/天'
      },{
        value: 2,
        name: '3次/天'
      },{
        value: 3,
        name: '1次/天'
      },{
        value: 4,
        name: '1次/周'
      },{
        value: '',
        name: '停止监测'
      }],
      monitortime: ['03', '06', '09', '12', '15', '18', '21', '24'],
      monitortime_min: 8,
      monitortime_max: 8,
      dialogtype: 0, /** 0：新增；1：续订；2：修改 */
      dialogtitle: '新增订阅',
      pickerOptions: {
        disabledDate: (time)=>{
          let that = this
          return that.dealDisabledDate(time)
        }
      },
      addsubscriptionrules: {
        brandid: { required: true, message: '不能为空', trigger: 'blur' },
        mainid: { required: true, message: '不能为空', trigger: 'blur' },
        name: { required: true, message: '不能为空', trigger: 'blur' },
        init: { required: true, message: '不能为空', trigger: 'blur' },
        expire: { required: true, message: '不能为空', trigger: 'blur' },
        packageid: { required: true, message: '不能为空', trigger: 'blur' },
        channel: { required: true, message: '不能为空', trigger: 'blur' },
        category: { required: true, message: '不能为空', trigger: 'blur' },
      },
      mylabel: '',
      duration: 0,
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false,
      adddisabled: false,
      editdisabled: false,
      showsaletype: false,
      saletype: false,
      addBrandDialog: false
    }
  },

  mounted(){
    // this.getSubscriptionList()
    this.getUser()
    this.getAgency()
    this.getBrand()
    this.getChannel()
    this.getPackage()
  },    
    
  methods: {    
    /**
     * 获取用户mainid
     */
    getUserMainid: function(uid){
      let that = this
      let userobj = {}
      userobj = that.mainids.find(function(item){
        return item.userId === uid
      })
      that.addform.mainid = userobj.mainId
    },

    /**
     * 获取代理mainid
     */
    getAgencyMainid: function(uid){
      let that = this
      let userobj = {}
      userobj = that.dmainids.find(function(item){
        return item.userId === uid
      })
      that.addform.dmainid = userobj.mainId
      that.addform.duserid = userobj.userId
    },

    /**
     * 获取主负责人mainid
     */
    getCSMMainid: function(uid){
      let that = this
      let userobj = {}
      userobj = that.mainids1.find(function(item){
        return item.userId === uid
      })
      that.addform.CSM = userobj.userId
    },
    
    /**
     * 获取副负责人mainid
     */
     getDepCSMMainid: function(uid){
      let that = this
      let userobj = {}
      userobj = that.mainids1.find(function(item){
        return item.userId === uid
      })
      that.addform.DepCSM = userobj.userId
    },

    /**
     * 获取渠道名
     */
    getChannelName: function(cid){
      this.showsaletype = false
      for(let i=0; i<cid.length; i++){
        if(cid[i] * 1 === 1 || cid[i] * 1 === 2){
          this.showsaletype = true
        }
      }
    },

    /**
     * 选择套餐获取duration
     */
    selectPackage: function(pid){
      let that = this
      let packageobj = {}
      packageobj = that.packageids.find(function(item){
        return item.id === pid
      })
      that.duration = packageobj.duration
      if(that.addform.init !== ''){
        let _expire = that.$moment(that.addform.init).add(that.duration, 'months')
        that.addform.expire = that.$moment(_expire).subtract(1, 'days')
      }
    },

    /**
     * 自动获取套餐到期日
     */
    getExpireDate: function(){
      let that = this
      let _expire = that.$moment(that.addform.init).add(that.duration, 'months')
      that.addform.expire = that.$moment(_expire).subtract(1, 'days')
    },


    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize4', val)
      that.getSubscriptionList()
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.query.page = val
      that.getSubscriptionList()
    },

    /**
     * 隐藏对话框
     */
    cancelDialog: function(refs){
      let that = this
      that.addform = {
        brandid: '',
        mainid: '',
        name: '',
        init: '',
        expire: '',
        packageId: '',
        channel: '',     
        category: '',
        userId: '',
        channelname: '',
        dmainid: '',
        tscount: null,
        tscountadd: 0,
        saletype: false,
        duserid: '',
        url: '',
        monitortype: '',
        monitortime: [],
        CSM: '',
        DepCSM: ''
      }
      that.checkexpire = false
      that.$refs[refs].resetFields()
      that.addSubscriptionDialog = false
    },

    /**
     * 添加订阅弹窗
     */
    addSubscription: function(){
      let that = this
      that.addform = {
        brandid: '',
        mainid: '',
        name: '',
        init: '',
        expire: '',
        packageId: '',
        channel: '',
        category: '',
        userId: '',
        channelname: '',
        dmainid: '',
        tscount: null,
        tscountadd: 0,
        saletype: false,
        duserid: '',
        url: '',
        monitortype: 1,
        monitortime: ['03', '06', '09', '12', '15', '18', '21', '24'],
        CSM: '',
        DepCSM: ''
      }
      that.dialogtype = 0
      that.addSubscriptionDialog = true
    },

    /**
     * 获取品牌列表
     */
    getSubscriptionList: function(){
      let that = this
      let url = that.API_URL + '/sys/subscription/list'
      let query = that.query
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          that.totalbrand = data.results[0][0].Count
          let lists = data.results[1]
          lists.forEach(function(res){
            res.expire = that.$moment(res.expire).utc().local().format('YYYY-MM-DD')
            res.init = that.$moment(res.init).utc().local().format('YYYY-MM-DD')
            res.tscountstr = res.tsTcount == null || res.tsTcount == '' || res.tsTcount == 0 ? 
                              '未开通' : res.tsTcount/1 >= 9999999 ? res.tscount + '(包月)' : res.tscount/1 + '/' + res.tsTcount/1
            res.daysleft = that.dayLeft(res.expire, res.status)
            res.saletype = res.saletype * 1 === 2 ? true : false
            res.monitortype = res.monitortype == 0 ? '' : res.monitortype
          })
          that.tablelist = lists
          that.loading = false
        },
        error: function(response) {
          console.log('getSubscriptionList', response)
        }
      })
    },

    /**
     * 格式化过期天数
     */
    dayLeft: function(expire, status){
      let daysleft = ''
      let that = this
      let todaydate = new Date()
      if(that.$moment(expire).diff(that.$moment(todaydate).utc().local().format('YYYY-MM-DD'),'days') >= 0 && status/1 === 1 ){
        daysleft = that.$moment(expire).diff(that.$moment(todaydate).utc().local().format('YYYY-MM-DD'),'days') + 1
      }else{
        daysleft = '停用'
      }
      return daysleft
    },

    /**
     * 查找用户
     */
    getUser: function(email){
      let that = this
      let url = that.API_URL + '/sys/users/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {search: email},
        success: function(data) {
          that.mainids1 = JSON.parse(JSON.stringify(data.results))
          let _u = data.results.filter(item => {
            return item.roleid/1 != 2 && item.roleid/1 != 3
          })
          that.mainids = _u
        },
        error: function(response) {
          console.log('getUser', response)
        }
      })
    },

    /**
     * 查找代理
     */
    getAgency: function(){
      let that = this
      let url = that.API_URL + '/sys/users/dlist'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          let _d = [{
            email: '无',
            mainId: 0,
            userId: 0
          }]
          _d = _d.concat(data.results)
          that.dmainids = _d
        },
        error: function(response) {
          console.log('getAgency', response)
        }
      })
    },

    /**
     * 查找品牌
     */
    getBrand: function(brand){
      let that = this
      let url = that.API_URL + '/sys/brand/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        //data: {search: brand, type: 1},
        data: {search: brand},
        success: function(data) {
          that.brandids = data.results
        },
        error: function(response) {
          console.log('getBrand', response)
        }
      })
    },

    /**
     * 查找渠道
     */
    getChannel: function(channel){
      let that = this
      let url = that.API_URL + '/sys/channel/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {search: channel},
        success: function(data) {
          that.channels = data.results
        },
        error: function(response) {
          console.log('getChannel', response)
        }
      })
    },

    /**
     * 查找套餐
     */
    getPackage: function(pack){
      let that = this
      let url = that.API_URL + '/sys/package/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {search: pack},
        success: function(data) {
          that.packageids = data.results
        },
        error: function(response) {
          console.log('getPackage', response)
        }
      })
    },
    
    /**
     * 确定添加
     */
    confirmAdd: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if(valid){
          let url = that.API_URL + '/sys/subscription/add'
          if(that.addform.monitortype == 2 && that.addform.monitortime.length < 2){
            that.$message.error('必须选择监测时间')
            return
          }
          if(that.addform.monitortype == 3 && that.addform.monitortime.length < 1){
            that.$message.error('必须选择监测时间')
            return
          }
          let query = {
            brandid: that.addform.brandid,
            mainid: that.addform.mainid,
            name: that.addform.name,
            init: that.$moment(that.addform.init).format('YYYY-MM-DD 00:00:00'),
            expire: that.$moment(that.addform.expire).format('YYYY-MM-DD 23:59:59'),
            packageid: that.addform.packageid,
            channel: that.addform.channel.join(','),
            category: that.addform.category,
            userid: that.addform.userId,
            channelname: '',
            dmainid: that.addform.dmainid,
            tscount: that.checkexpire == true ? 9999999 : that.addform.tscount,
            saletype: that.addform.saletype,
            duserid: that.addform.duserid,
            url: that.addform.url,
            monitortype: that.addform.monitortype,
            monitortime: that.addform.monitortime.join(','),
            isDefault: that.isDefault,
            CSM: that.addform.CSM,
            DepCSM: that.addform.DepCSM
          }
          that.adddisabled = true
          $.ajax({
            url: url,
            type: "POST",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            data: query,
            success: function(data) {
              console.log('confirmAdd', data)
              that.addSubscriptionDialog = false
              that.adddisabled = false
              that.addform = {
                brandid: '',
                mainid: '',
                name: '',
                init: '',
                expire: '',
                packageId: '',
                channel: '',     
                category: '',
                userId: '',
                channelname: '',
                dmainid: '',
                tscount: null,
                tscountadd: 0,
                saletype: false,
                duserid: '',
                url: '',
                monitortype: 1,
                monitortime: ['03', '06', '09', '12', '15', '18', '21', '24'],
                CSM: '',
                DepCSM: ''
              },
              that.isDefault = 1
              that.monitortime_min =  8
              that.monitortime_max = 8
              that.checkexpire = false
              that.getSubscriptionList()
            },
            error: function(response) {
              console.log('confirmAdd', response)
            }
          })
        }else{
          return false
        }
      })
    },

    /**
     * dealDisabledDate
     */
    dealDisabledDate: function(time){
      let that = this
      return time.getTime() <= new Date(that.addform.init).getTime()
    },

    /**##########################################################
     * 新增品牌 #################################################
     ###########################################################*/
    addBrand: function(){
      let that = this
      that.disableaddbtn = false
      that.addform = {
        name: '',
        brand: '',
        logo: '',
        keywords: '',
        trademark: ''
      }
      that.addBrandDialog = true
    },

    /**
     * 跳转至新增用户
     */
    goToAddUser: function(){
      let that = this
      that.$router.push({name: 'User'})
    },

    /**
     * 选择监测频次
     */
    selectType: function(val){
      let that = this
      that.isDefault = 1
      if(val == 1){
        this.addform.monitortime = ['03', '06', '09', '12', '15', '18', '21', '24']
        this.monitortime_min = 8,
        this.monitortime_max = 8
      }
      if(val == 2){
        this.addform.monitortime = this.isDefault == 1 ? ['03', '12', '18'] : []
        this.monitortime_min = this.isDefault == 1 ? 3 : 0,
        this.monitortime_max = 3
      }
      if(val == 3){
        this.addform.monitortime = this.isDefault == 1 ? ['03'] : []
        this.monitortime_min = this.isDefault == 1 ? 1 : 0,
        this.monitortime_max = 1
      }
      if(val == 4){
        this.addform.monitortime = ['03']
        this.monitortime_min = 0,
        this.monitortime_max = 1
      }
      if(val == ''){
        this.addform.monitortime = []
        this.monitortime_min = 0,
        this.monitortime_max = 0
      }
    },

    /**
     * 切换默认和自定义
     */
    selectDefault: function(val){
      let that = this
      let type = that.addform.monitortype
      if(val == 0){
        // this.addform.monitortime = []
        if(type == 2){
          that.monitortime_min = 0,
          that.monitortime_max = 3
        }
        if(type == 3){
          that.monitortime_min = 0,
          that.monitortime_max = 1
        }
      }
      if(val == 1){
        that.addform.monitortime = []
        if(type == 2){
          that.addform.monitortime = ['03', '12', '18']
          that.monitortime_min = 3,
          that.monitortime_max = 3
        }
        if(type == 3){
          that.addform.monitortime = ['03']
          that.monitortime_min = 1,
          that.monitortime_max = 1
        }
      }
    }
  }
}
</script>